import { TrendingUp } from "lucide-react";

interface ResultItem {
  metric: string;
  before: string;
  after: string;
}

interface UseCaseResultsProps {
  results: ResultItem[];
  accentColor: string;
  period: string;
}

const UseCaseResults = ({ results, accentColor, period }: UseCaseResultsProps) => {
  return (
    <section className="relative py-20 lg:py-24 bg-[#0A0A0F]">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0F172A]/30 to-transparent" />

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-12 text-center animate-fade-up">
            <div className="inline-flex items-center gap-3 mb-4">
              <TrendingUp className="h-5 w-5" style={{ color: accentColor }} />
              <span className="text-sm font-medium uppercase tracking-wider text-white/50">
                Les r&eacute;sultats
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Apr&egrave;s {period}
            </h2>
          </div>

          {/* Results table */}
          <div className="rounded-2xl p-[1px] bg-gradient-to-b from-white/[0.1] to-transparent animate-fade-up [animation-delay:100ms]">
            <div className="rounded-2xl bg-[#0F0F14]/90 backdrop-blur-xl overflow-hidden">
              {/* Table header */}
              <div className="grid grid-cols-3 gap-4 px-6 py-4 bg-white/[0.02] border-b border-white/[0.05]">
                <div className="text-sm font-semibold text-white/50 uppercase tracking-wider">
                  M&eacute;trique
                </div>
                <div className="text-sm font-semibold text-white/50 uppercase tracking-wider text-center">
                  Avant
                </div>
                <div className="text-sm font-semibold text-white/50 uppercase tracking-wider text-center">
                  Apr&egrave;s
                </div>
              </div>

              {/* Table rows */}
              {results.map((result, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-3 gap-4 px-6 py-5 ${
                    index !== results.length - 1 ? "border-b border-white/[0.05]" : ""
                  } hover:bg-white/[0.02] transition-colors`}
                >
                  <div className="text-white/70 font-medium">
                    {result.metric}
                  </div>
                  <div className="text-center text-white/40">
                    {result.before}
                  </div>
                  <div className="text-center font-semibold" style={{ color: accentColor }}>
                    {result.after}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCaseResults;
